/** Preferencia global de sucursal (análogo a idCompania). */

export function readGlobalNroSuc(): number | null {
  try {
    const raw = localStorage.getItem('nroSuc') || localStorage.getItem('sucursal') || '0';
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function persistGlobalNroSuc(nroSuc: number): void {
  if (!Number.isFinite(nroSuc) || nroSuc <= 0) return;
  try {
    localStorage.setItem('nroSuc', String(nroSuc));
    localStorage.setItem('sucursal', String(nroSuc));
  } catch {}
}

export function clearGlobalNroSuc(): void {
  try {
    localStorage.removeItem('nroSuc');
    localStorage.removeItem('sucursal');
  } catch {}
}
